import Vue from 'vue'
import moment from 'moment'
import {api, endpoints} from '@/api'

const internalDateFormat = 'YYYY-MM-DD'


const defaultProfile = () => ({
  show_inactive_projects: false,
  show_inactive_employees: false
})

const state = {
  knownProjectSelectablesLoading: false,
  knownProjectSelectables: [],
  knownEmployeeSelectablesLoading: false,
  knownEmployeeSelectables: [],
  selectedEmployeesUntouched: true,
  selectedEmployees: [],
  selectedProjectsUntouched: true,
  selectedProjects: [],
  selectedTenant: null,
  selectedTenantObj: null,
  employeePermission: undefined,
  profile: defaultProfile(),
  profileLoading: false,
  knownTenants: [],
  //periodSelectionGuidedByCategory: true,
  periodSelection: "currentWeek",
  start: moment().startOf('isoweek').format(internalDateFormat),
  end: moment().endOf('isoweek').format(internalDateFormat)
}

const getters = {
  knownProjectSelectables: state => state.knownProjectSelectables,
  knownProjectSelectablesLoading: state => state.knownProjectSelectablesLoading,
  knownEmployeeSelectables: state => state.knownEmployeeSelectables,
  knownEmployeeSelectablesLoading: state => state.knownEmployeeSelectablesLoading,
  selectedEmployees: (state, getters) => {
    if (state.selectedEmployeesUntouched && state.selectedEmployees.some(e => e.id === getters.employee.id)) {
      return [getters.employee]
    }
    return state.selectedEmployees
  },
  selectedEmployeesNeedHighlighting: (state) => {
    return !state.selectedEmployeesUntouched
  },
  selectedProjects: state => state.selectedProjects,
  selectedProjectsNeedHighlighting: (state) => {
    return !state.selectedProjectsUntouched && state.selectedProjects.length > 0
  },
  selectedTenant: state => state.selectedTenant,
  selectedTenantObj: state => state.selectedTenantObj,
  employeePermission: state => state.employeePermission,
  knownTenants: state => state.knownTenants,
  profile: state => state.profile,
  profileLoading: state => state.profileLoading,
  selectedPeriod: state => {
    return {
      selection: state.periodSelection,
      start: moment(state.start, internalDateFormat),
      end: moment(state.end, internalDateFormat),
    }
  },
  selectedPeriodFilter: state => {
    return {
      taskday__gte: state.start,
      taskday__lte: state.end,
    }
  },
  daysInSelectedPeriod: state => {
    var dates = []
    var startDate = moment(state.start)
    var endDate = moment(state.end)
    while (startDate <= endDate) {
      dates.push(moment(startDate))
      startDate = startDate.add(1, 'days')
    }
    return dates
  },
}

const actions = {
  async fetchKnownProjectSelectables ({commit, getters}) {
    const selectedTenant = getters.selectedTenant
    if (selectedTenant !== null) {
      commit('knownProjectSelectablesLoading', {loading: true})
      try {
        const filters = {tenant: selectedTenant, ordering: "name"}
        if (!getters.profile.show_inactive_projects) {
          filters.inactive = false
        }
        const r = await api(endpoints.fetch_project(), filters, {method: 'GET'})
        if (r.ok) {
          const projects = await r.json()
          commit('updateKnownProjectSelectables', {projects})
        } else {
          // TODO: error handling
        }
      } finally {
        commit('knownProjectSelectablesLoading', {loading: false})
      }
    } else {
      commit('updateKnownProjectSelectables', {projects: []})
    }
  },
  async fetchKnownEmployeeSelectables ({commit, getters}) {
    const selectedTenant = getters.selectedTenant
    if (selectedTenant !== null) {
      commit('knownEmployeeSelectablesLoading', {loading: true})
      try {
        const filters = {tenants: selectedTenant, ordering: "last_name"}
        if (!getters.profile.show_inactive_employees) {
          filters.inactive = false
        }
        const r = await api(endpoints.fetch_employee(), filters, {method: 'GET'})
        if (r.ok) {
          const employees = await r.json()
          commit('updateKnownEmployeeSelectables', {employees})
        } else {
          // TODO: error handling
        }
      } finally {
        commit('knownEmployeeSelectablesLoading', {loading: false})
      }
    } else {
      commit('updateKnownEmployeeSelectables', {employees: []})
    }
  },
  updateSelectedEmployees ({commit, state}, {employees}) {
    // cancel if there is no change
    if (state.selectedEmployees === employees) {
      return
    }
    if (state.selectedEmployees !== undefined) {
      if (employees.length === state.selectedEmployees.length) {
        let existing = 0
        state.selectedEmployees.map(item => {
          if (employees.some(item2 => item2.id === item.id)) {
            existing++
          }
        })
        if (existing === state.selectedEmployees.length) {
          return
        }
      }
    }
    commit(
      'updateSelectedEmployees',
      {
        employees: employees
      }
    )
  },
  updateSelectedProjects ({commit, state}, {projects}) {
    // cancel if there is no change
    if (state.selectedProjects === projects) {
      return
    }
    if (state.selectedProjects !== undefined) {
      if (projects.length === state.selectedProjects.length) {
        let existing = 0
        state.selectedProjects.map(item => {
          if (projects.some(item2 => item2.id === item.id)) {
            existing++
          }
        })
        if (existing === state.selectedProjects.length) {
          return
        }
      }
    }
    commit(
      'updateSelectedProjects',
      {
        projects: projects
      }
    )
  },
  updateemployeePermission ({commit, state}, {assignment}) {
    commit(
      'updateemployeePermission',
      {
        type: assignment
      }
    )
  },
  updateSelectedPeriod ({commit, state}, {selection, end, start}) {
    commit(
      'updateSelectedPeriod',
      {
        selection: selection,
        start: start,
        end: end
      }
    )
  },
  async getProfile ({commit, getters}) {
    commit('profileLoading', {profileLoading: true})
    try {
      const r = await api(endpoints.fetch_profile(), {employee__user__id: getters.userid, details: true}, {method: 'GET'})
      if (r.ok) {
        const profiles = await r.json()
        if (profiles.length === 1) {
          commit('updateProfile', {profile: profiles[0]})
        } else {
          console.log("multiple profiles found")
        }
      } else {
      }
    } catch (err) {
      console.log(err)
    } finally {
      commit('profileLoading', {profileLoading: false})
    }
  },
  async setProfile ({commit, getters, state}, {profile}) {
    commit('profileLoading', {profileLoading: true})
    try {
      const r = await api(endpoints.fetch_profile(profile.id || getters.profile.id), profile, {method: 'PATCH'})
      if (r.ok) {
        commit('updateProfile', {profile: await r.json()})
      }
    } catch (err) {
      conosle.log(err)
    } finally {
      commit('profileLoading', {profileLoading: false})
    }
  },
}

const mutations = {
  knownProjectSelectablesLoading (state, {loading}) {
    state.knownProjectSelectablesLoading = loading
  },
  updateKnownProjectSelectables (state, {projects}) {
    state.knownProjectSelectables.splice(0, state.knownProjectSelectables.length, ...projects)
  },
  knownEmployeeSelectablesLoading (state, {loading}) {
    state.knownEmployeeSelectablesLoading = loading
  },
  updateKnownEmployeeSelectables (state, {employees}) {
    state.knownEmployeeSelectables.splice(0, state.knownEmployeeSelectables.length, ...employees)
  },
  updateSelectedEmployees (state, {employees}) {
    state.selectedEmployees = employees
    state.selectedEmployeesUntouched = false
  },
  resetSelectedEmployees (state) {
    state.selectedEmployees.splice(0, state.selectedEmployees.length)
    state.selectedEmployeesUntouched = true
  },
  updateSelectedProjects (state, {projects}) {
    state.selectedProjects = projects
    state.selectedProjectsUntouched = false
  },
  resetSelectedProjects (state) {
    state.selectedProjects.splice(0, state.selectedProjects.length)
    state.selectedProjectsUntouched = true
  },
  updateSelectedPeriod (state, {selection, start, end}) {
    state.periodSelection = selection
    state.start = start.format(internalDateFormat)
    state.end = end.format(internalDateFormat)
  },
  updateSelectedTenant (state, {tenant}) {
    state.selectedTenant = tenant
  },
  updateemployeePermission (state, {assignment}) {
    state.employeePermission = assignment
  },
  updateProfile (state, {profile}) {
    if (profile !== null) {
      const keys = Object.keys(profile)
      const anyChanges = keys.some(key => {
        return state.profile[key] !== profile[key]
      })
      if (anyChanges) {
        // Set to undefined before changing one property
        this._vm.$set(state, 'profile', profile)
      }
    } else {
      this.profile = defaultProfile()
    }
  },
  updateKnownTenants (state, {tenants}) {
    state.knownTenants.splice(0, state.knownTenants.length, ...tenants)
  },
  updateSelectedTenantObj (state, {tenant}) {
    this._vm.$set(state, 'selectedTenantObj', tenant)
  },
  profileLoading (state, {profileLoading}) {
    state.profileLoading = profileLoading
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
